import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the search modals for tv and/or tv-zip
const tvProducts = ["tv", "tv-zip"];
tvProducts.forEach(product => {
  if (document.querySelector(`.js-${product}-profile-search-form-city-state`)) {
    placesAutoComplete.initializeCityState(
      `.js-${product}-profile-search-form-city-state`,
      null,
      pageData.get("currentCountry")
    );
  }
});
